import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_URL || "http://187.127.165.240:5000";

export default function VerifyCertificate() {
  const { verifyId } = useParams();
  const [status, setStatus] = useState("loading");
  const [cert, setCert] = useState(null);

  useEffect(() => {
    fetch(`${API_BASE}/verify/${verifyId}`)
      .then((r) => r.json())
      .then((data) => {
        if (data.success) {
          setCert(data.certificate);
          setStatus("valid");
        } else setStatus("invalid");
      })
      .catch(() => setStatus("invalid"));
  }, [verifyId]);

  if (status === "loading") return <Center text="⏳ Verifying..." />;
  if (status === "invalid") return <Center text="❌ Invalid Certificate" color="#dc2626" />;
  // completionDate + 10 days
  const issuedOn = cert?.completionDate
    ? (() => {
        const date = new Date(cert.completionDate);
        date.setDate(date.getDate() + 10);

        return date.toLocaleDateString("en-GB", {
          day: "numeric",
          month: "long",
          year: "numeric",
        });
      })()
    : "";
  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "sans-serif", background: "#f0f4ff" }}>
      <div style={{ background: "#fff", borderRadius: 16, padding: 40, boxShadow: "0 4px 24px rgba(0,0,0,0.1)", textAlign: "center", maxWidth: 420 }}>
        <div style={{ fontSize: 48, color: "#059669" }}>✅</div>
        <h2 style={{ color: "#1e1b4b" }}>Genuine Certificate</h2>
        <p style={{ color: "#64748b", marginBottom: 16 }}>Uncodemy Edutech Pvt. Ltd.</p>
        <div style={{ textAlign: "left", background: "#f8fafc", borderRadius: 10, padding: 16, border: "1px solid #e2e8f0" }}>
          <p><strong>Name:</strong> {cert.name}</p>
          <p><strong>Course:</strong> {cert.course}</p>
          <p><strong>Duration:</strong> {cert.months} Months</p>
          <p><strong>Completion:</strong> {cert.completionDate}</p>
          <p><strong>Issued On:</strong>  {issuedOn}</p>
        </div>
      </div>
    </div>
  );
}

function Center({ text, color = "#ff5421" }) {
  return <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18, color, fontFamily: "sans-serif" }}>{text}</div>;
}